import { css } from 'styled-components';
import {
  height,
  HeightProps,
  maxHeight,
  MaxHeightProps,
  maxWidth,
  MaxWidthProps,
  minHeight,
  MinHeightProps,
  minWidth,
  MinWidthProps,
  width,
  WidthProps
} from 'styled-system';

export interface SizeProps
  extends MinWidthProps,
    MinHeightProps,
    WidthProps,
    HeightProps,
    MaxWidthProps,
    MaxHeightProps {}

const flexHelper = css`
  ${minWidth};
  ${minHeight};
  ${width};
  ${height};
  ${maxWidth};
  ${maxHeight};
`;

export default flexHelper;
